/* Contact-page entry for the existing NEBULITE website inbox. */
(() => {
  'use strict';

  const elementName = 'nebulite-contact-chat';
  if (customElements.get(elementName)) return;

  const baseUrl = 'https://support.nebulite.berlin';
  const sdkUrl = `${baseUrl}/packs/js/sdk.js`;
  const websiteToken = 'hjde4M9tMyxYJPzFCYHLVBMy';
  const startupTimeoutMs = 15000;
  const entries = new Set();
  const messages = {
    de: {
      button: 'Support-Chat öffnen',
      loading: 'Chat wird geladen …',
      ready: 'Schreib deine Nachricht im Chatfenster. Falls es nicht erscheint, nutze bitte das Formular oder E-Mail.',
      failed: 'Der Chat konnte nicht geöffnet werden. Nutze bitte das Formular unten oder schreibe uns eine E-Mail.'
    },
    en: {
      button: 'Open support chat',
      loading: 'Loading chat …',
      ready: 'Write your message in the chat window. If it does not appear, please use the form or email us.',
      failed: 'The chat could not be opened. Please use the form below or email us.'
    }
  };
  let state = 'idle';
  let runStarted = false;
  let startupTimer;

  function update() {
    for (const entry of entries) entry.update(state);
  }

  function fail() {
    if (state === 'failed') return;
    state = 'failed';
    clearTimeout(startupTimer);
    window.removeEventListener('chatwoot:ready', onReady);
    update();
  }

  function open() {
    try {
      window.$chatwoot.toggle('open');
    } catch (_) {
      fail();
    }
  }

  function onReady() {
    if (state !== 'loading' || !runStarted) return;
    if (typeof window.$chatwoot?.toggle !== 'function') {
      fail();
      return;
    }
    state = 'ready';
    clearTimeout(startupTimer);
    window.removeEventListener('chatwoot:ready', onReady);
    open();
    update();
  }

  function start() {
    if (state === 'ready') {
      open();
      return;
    }
    if (state !== 'idle') return;

    // Never take over or initialise a second, potentially different inbox.
    if (window.chatwootSDK || window.$chatwoot || window.chatwootSettings ||
        document.querySelector(`script[src="${sdkUrl}"]`)) {
      fail();
      return;
    }

    state = 'loading';
    update();
    try {
      const pageLanguage = document.documentElement.lang.toLowerCase();
      window.chatwootSettings = {
        hideMessageBubble: true,
        locale: pageLanguage === 'de' || pageLanguage.startsWith('de-') ? 'de' : 'en',
        useBrowserLanguage: false
      };
      window.addEventListener('chatwoot:ready', onReady);
      startupTimer = setTimeout(fail, startupTimeoutMs);

      const script = document.createElement('script');
      script.src = sdkUrl;
      script.async = true;
      script.onerror = fail;
      script.onload = () => {
        if (state !== 'loading') return;
        if (runStarted || window.$chatwoot || typeof window.chatwootSDK?.run !== 'function') {
          fail();
          return;
        }
        runStarted = true;
        try {
          window.chatwootSDK.run({ websiteToken, baseUrl });
        } catch (_) {
          fail();
        }
      };
      document.head.appendChild(script);
    } catch (_) {
      fail();
    }
  }

  class ContactChat extends HTMLElement {
    connectedCallback() {
      if (!this.button) {
        this.button = this.querySelector('button');
        this.status = this.querySelector('[data-chat-status]');
        if (!this.button || !this.status) return;
        this.copy = messages[this.dataset.locale === 'de' ? 'de' : 'en'];
        this.button.setAttribute('aria-describedby', this.status.id);
        this.button.addEventListener('click', start);
      }
      entries.add(this);
      this.update(state);
    }

    disconnectedCallback() {
      entries.delete(this);
    }

    update(currentState) {
      this.button.disabled = currentState === 'loading' || currentState === 'failed';
      this.button.setAttribute('aria-busy', String(currentState === 'loading'));
      this.button.textContent = currentState === 'loading' ? this.copy.loading : this.copy.button;
      this.status.hidden = currentState === 'idle';
      this.status.textContent = currentState === 'idle' ? '' : this.copy[currentState];
    }
  }

  customElements.define(elementName, ContactChat);
})();
